import { Controller } from "@hotwired/stimulus";
import { OTHER_VALUE, percentageToRate } from "@/javascript/lib/vat_rate";

export default class extends Controller {
  static targets = ["select", "custom", "customWrapper", "hidden"];

  selectChanged() {
    const value = this.selectTarget.value;
    const isOther = value === OTHER_VALUE;

    this.customWrapperTarget.classList.toggle("hidden", !isOther);

    if (!isOther) {
      this.customTarget.value = "";
      this.hiddenTarget.value = value;
      return;
    }

    this._writeCustomToHidden();
  }

  customChanged() {
    this._writeCustomToHidden();
  }

  _writeCustomToHidden() {
    const raw = this.customTarget.value;

    if (raw === "") {
      this.hiddenTarget.value = "";
      return;
    }

    const parsed = parseFloat(raw);
    this.hiddenTarget.value = Number.isNaN(parsed)
      ? ""
      : percentageToRate(parsed);
  }
}
